import CirgsCustomerAttachmentsSection from './CirgsCustomerAttachmentsSection';

export default CirgsCustomerAttachmentsSection;
